import { find } from "lodash"

export const enricheLotWithAuction = (lots: any, auctions: any) => {
  return lots?.map((lot: any) => {
    return {
      ...(lot.node ? lot.node : lot),
      auction: find(auctions, a => {
        return a.id === (lot.auctionId || lot.node.auctionId)
      }),
    }
  })
}

export const getAuctionsIds = (lots: any) => {
  return lots?.map((lot: any) => {
    return lot?.auctionId || lot?.node?.auctionId
  })
}
